import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from '@heroicons/react/24/solid';
import AIChat from './AIChat';
import '../styles/AIChat.css';

const AIChatButton = ({ onClick, isOpen }) => {
  return (
    <>
      <motion.button
        onClick={onClick}
        className={`fixed bottom-6 left-6 z-40 flex items-center justify-center p-4 rounded-full bg-gradient-to-r from-[#444444] via-[#6E3AFF] to-[#BEAF87] text-white shadow-lg hover:shadow-xl transition-all duration-300 ${
          isOpen ? 'scale-90 opacity-0' : 'scale-100 opacity-100'
        }`}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        animate={{ opacity: isOpen ? 0 : 1 }}
        initial={{ opacity: 0, scale: 0.8 }}
        exit={{ opacity: 0, scale: 0.8 }}
      >
        <SparklesIcon className="h-6 w-6" />
      </motion.button>

      {isOpen && <AIChat onClose={() => onClick(false)} />}
    </>
  );
};

export default AIChatButton;
